/**
 * テナントPaid連携
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
import * as types from '../../../../mutation-types/admin-types'
import {ADMIN_CONTRACTOR_RESET_CONDITION} from "../../../../mutation-types/admin-types";

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/contractors`

const contractor = {
  namespaced: true,
  actions: {
    create ({ commit }, { contractor_id, tenant_id }) {
      const api_path = `${API_PATH}/${contractor_id}/tenants/${tenant_id}/connect_paid`
      return new Promise( ( resolve, _reject ) => {
        Vue.$http.post(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: 'Paid連携を完了しました' }, { root: true })
          resolve(content)
        } )
      })
    },  
  },
}

export default contractor
